import axios from "axios";

export default function updateAdmin({ uuid, email, username }) {
  return new Promise((resolve, reject) => axios
    .put(`/account/system-admin/api/v1/admin/${uuid}/details`, {
      email, username,
    })
    .then((response) => resolve(response.data))
    .catch((error) => reject(error.message))
  );
}
